import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-error-diamond-bold',
    templateUrl: './icon-error-diamond-bold.component.html',
    styleUrls: ['./icon-error-diamond-bold.component.css'],
    standalone: true,
})
export class IconErrorDiamondBoldComponent {
  @Input() color = '#b91c1c';
  @Input() width = '24';
  @Input() height = '24';
}
